export default __webpack_public_path__ + "static/media/RAJAM jewellers.966d66f2.jpg";